import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const getVoucherDuration = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/voucher-durations`);
  return data;
});


export const addVoucherDuration = catchAsync(async (body) => {
  const data = await axiosInstance.post("salon/voucher-durations", body);
  return data;
});